/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import React, { useRef } from 'react';
import Dropzone from 'react-dropzone';
import { useTranslation } from 'react-i18next';

import {
  useHandleDeleteDocuments,
  useHandleUploadDocuments,
} from '../../../utils/DocumentsHooks';
import { USER_PICTURE_FILE_TYPES } from '../../../config/accepted-file-types';
import { PROFILE_PICTURE } from '../../../config/documents';
import { Avatar } from './Avatar';
import ToastStore from '../../../stores/ToastStore';
import AdminServerActionCreators from '../../../actions/AdminServerActionCreators';
import SessionStore from '../../../stores/SessionStore';

export function AvatarWithUpload({
  userId,
  altName,
  className = null,
  avatarClassName = null,
  style = null,
}) {
  const avatarRef = useRef();
  const { t } = useTranslation();

  const { handleDelete } = useHandleDeleteDocuments((docs) =>
    console.log(
      `Previous avatar ${docs[0].name} has been successfully deleted.`,
    ),
  );

  const handleDrop = async (acceptedImage) => {
    if (acceptedImage.length) {
      return handleUpload(acceptedImage, PROFILE_PICTURE.value).then(
        async () => {
          const oldDoc = avatarRef.current?.getOldDocument();

          if (oldDoc) {
            await handleDelete([oldDoc]);
          }

          const user = SessionStore.getUser();

          if (user._type === 'Carrier') {
            AdminServerActionCreators.updatedCarrier(user._id, user);
          } else if (user._type === 'Shipper') {
            AdminServerActionCreators.updatedShipper(user._id, user);
          } else if (user._type === 'Driver') {
            AdminServerActionCreators.receiveDriver(user);
          }
        },
      );
    }

    ToastStore.getNotifications().push({
      body: t('INVALID_AVATAR_EXTENSION'), // 'Invalid image format. Only [jpg, png, heic, tiff] files are allowed.'
      level: 'error',
    });
    ToastStore.emitChange();
  };

  const { handleUpload } = useHandleUploadDocuments(
    { id: userId },
    null,
    async (shipment, stop, type, uploadedData, userVisibility) => {
      avatarRef.current?.refetchAvatar();
    },
    (shipment, stop, e) => {
      console.log(e);
    },
  );

  return (
    <Dropzone
      className={className}
      style={style}
      accept={USER_PICTURE_FILE_TYPES}
      onDrop={handleDrop}
      multiple={false}
    >
      <Avatar
        key={userId}
        userId={userId}
        altName={altName}
        className={avatarClassName}
        ref={avatarRef}
      />
    </Dropzone>
  );
}
